import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AppState {
  preferenceDataUpdatedAt: number | null;
  setPreferenceUpdatedAt: (time: number) => void;
}

export const useAppStore = create<AppState>()(
  persist(
    (set) => ({
      preferenceDataUpdatedAt: null,
      setPreferenceUpdatedAt: (time: number) => set({ preferenceDataUpdatedAt: time }),
    }),
    {
      name: 'app',
      partialize: (state) => ({
        preferenceDataUpdatedAt: state.preferenceDataUpdatedAt,
      }),
    }
  )
);
